import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { callApiSaqsDelete } from "../services";
import { onClickDeleteSaqData } from "../modules/actions/index";

class DeleteSaqModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deletedId: null,
    };
  }

  deleteSaqRecord = () => {
    // console.log("deleteSaqRecord", this.props.deletedId);
    this.props.onClickDeleteSaqData({saqId:this.props.deletedId, history:this.props.history});
    document.getElementById("btnSaqDeleteConfirmationClose").click();
  };

  render() {
    return (
      <div
        className="modal fade"
        id="saqDeleteConfirmationModal"
        tabIndex="-1"
        aria-labelledby="saqDeleteConfirmationModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Delete SAQ</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure want to delete this? It can not be undone.</p>
            </div>
            <div className="modal-footer">
              <button
                id="btnSaqDeleteConfirmationClose"
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
              >
                No
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => this.deleteSaqRecord()}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClickDeleteSaqData,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DeleteSaqModal));
